import React from "react";
import { useSelector } from "react-redux";
import { Menu, Item, Separator } from "react-contexify";
import { Icon } from "../_components";
import { useModal, useTime, useMaps } from "../_contexts";
import { getDateFromPosition, ChronosDate } from "../_helpers";
import ReactTooltip from "react-tooltip";

export function ChronicleAddMenu() {
  const { items: timelines } = useSelector((state) => state.timelines);
  const { openModal } = useModal();
  const { toggleInteractiveMode } = useMaps();
  const { currentDate, calendar, granularity, unitsDisplay, scrollPosition } =
    useTime();

  const handleAddMap = (event) => {
    openModal("newMap");
  };

  const handleAddTimeline = (event) => {
    openModal("newTimeline");
  };

  const handleAddEvent = (ev) => {
    const startDate = new ChronosDate(currentDate, {
      calendar,
    });
    const segment = startDate.getTimelineSegment(granularity, {
      unitCountDisplay: unitsDisplay,
    });

    const offset = scrollPosition;

    const dateAtLine = startDate.getDateFromPosition(
      offset,
      granularity,
      segment.start,
      unitsDisplay
    );
    // const startDate = getDateFromPosition(
    //   segment,
    //   offset,
    //   granularity,
    //   unitsDisplay
    // );
    const newEvent = {
      timeline: null,
      // fromDate: '0',
      fromDate: dateAtLine,
      laneID: 0,
    };

    console.warn("ADD EVENT DATE: ", newEvent);
    openModal("newEvent", { eventItem: newEvent });
  };

  const handleChronicleSettings = (event) => {
    openModal("chronicleSettings");
  };

  const handleCreateMarker = () => {
    //set context map-marker-creating
    toggleInteractiveMode(true);
    console.log("Toggling Interactive Mode");
    //In leaflet map, add event listener dynamically
    //Create marker scaffold, inject coords from event
    //Remove context
  };

  ReactTooltip.rebuild();

  const tooltipID = "chronos-add-menu-tooltip";

  return (
    <Menu
      id="chronos-chronicle-add-menu"
      className="chronos-context-menu chronos-context-menu-global"
    >
      <Item onClick={handleAddMap}>
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Add Map
      </Item>
      <Item onClick={handleAddTimeline}>
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Add Timeline
      </Item>
      <Item
        onClick={handleAddEvent}
        disabled={!timelines || timelines.length === 0}
        data-for={tooltipID}
        data-tip={
          !timelines || timelines.length === 0
            ? `You must have a visible timeline before you can add an event`
            : `Tip: You can also right-click anywhere on a timeline to add a new event`
        }
      >
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Add Event
      </Item>
      <Item
        onClick={handleCreateMarker}
        data-for={tooltipID}
        data-tip={`Tip: You can also right-click anywhere on a map to add a marker`}
      >
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Add Marker
      </Item>
      {/* <Separator /> */}
      {/* <Item onClick={handleChronicleSettings}>
        <Icon icon="fas fa-cogs fa-fw" />
        &nbsp; Chronicle Settings
      </Item> */}
      <ReactTooltip id={tooltipID} effect="solid" />
    </Menu>
  );
}
